import React, { useEffect, useState } from 'react';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import * as yup from 'yup';
import '../posts/inputStyle.css';
import InputCustom from '../Auth/InputCustom';

const EditVersion = () => {
    const [currentVersion, setCurrentVersion] = useState();

    useEffect(()=>{
        axios
        .get(`https://arianaapp.arianaapply.com/api/V1/show-version-app`)
        .then((res) => {
            console.log('resV', res);
            setCurrentVersion(res.data)
        })
        .catch((err) => {
            console.log('errorV', err.response);
        });
    }, [])
    const initialValues = {
        code: '',
        discount: '',
        description: ''
    };
    const validationSchema = yup.object({
        version: yup.string().required('وارد کردن ورژن اپ الزامیست'),
    });
    const onSubmit = (state) =>
    {
        console.log('states', state);
        const { version } = state;
        axios.post('https://arianaapp.arianaapply.com/panel/edit-version/', {
            version,
            id: currentVersion._id
        }).then(res =>{
            console.log('creat-Version', res);
            Swal.fire({
                title: ' ورژن اپ با موفقیت ایجاد شد',
                icon: 'success',
            }).then(()=>{
                window.location.reload();
            })
        }).catch(err =>{
            console.log('creat-Version-err', err);
            Swal.fire({
                title: 'ورژن اپ ایجاد نشد',
                icon: 'error',
              })
        })
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: true,
        enableReinitialize: true,
      });
    return ( 
        <div className='index'>
        <form onSubmit={formik.handleSubmit}>
        <h2>ایجاد ورژن اپ</h2>
        <h4>ورژن فعلی: {currentVersion?.version}</h4>
        <InputCustom
            name='version'
            type='text'
            label=' ورژن اپ...'
            formikHandler={formik.getFieldProps('version')}
            formikErrors={formik.errors.version && formik.touched.version}
            formikErrorsName={formik.errors.version}
        />

        <div className='inputBox'>
      <button
        type='submit'
        className={!formik.isValid ? 'btn-gray' : 'btn-success'}
        disabled={!formik.isValid}>
        ثبت
      </button>
    </div>
        </form>
    </div>
     );
}

export default EditVersion;